/**
 * Eon API
 * The Eon.io REST API
 *
 * AUTOGENERATED: Do not edit the class manually.
 * Instead edit the .mustache file and run `node --run gen-openapi`
 */


export class UpdateCloudResourceConfigurationRequest {
  /**
  * Whether CDC is enabled for the resource
  */
  'enableCdcBackup'?: boolean | null;
  /**
  * Whether inventory backup is enabled for the resource
  */
  'enableInventoryBackup'?: boolean | null;
  /**
  * Whether the resource should have extended DynamoDB support enabled
  */
  'enableExtendedDynamoDbSupport'?: boolean | null;
  /**
  * The number of partitions to set for the DynamoDB resource
  */
  'setDynamoDbPartitions'?: number | null;

  static readonly discriminator: string | undefined = undefined;

  static readonly attributeTypeMap: Array<{name: string, baseName: string, type: string, format: string}> = [
    {
      "name": "enableCdcBackup",
      "baseName": "enableCdcBackup",
      "type": "boolean",
      "format": ""
    },
    {
      "name": "enableInventoryBackup",
      "baseName": "enableInventoryBackup",
      "type": "boolean",
      "format": ""
    },
    {
      "name": "enableExtendedDynamoDbSupport",
      "baseName": "enableExtendedDynamoDbSupport",
      "type": "boolean",
      "format": ""
    },
    {
      "name": "setDynamoDbPartitions",
      "baseName": "setDynamoDbPartitions",
      "type": "number",
      "format": "int64"
    }  ];

  static getAttributeTypeMap() {
    return UpdateCloudResourceConfigurationRequest.attributeTypeMap;
  }

  public constructor() {
  }
}

